import request from '../../services/request.service';
import config from '../../config';
import auth from '../../services/auth.service';
export const GET_CURRENT_USER = 'GET_CURRENT_USER';
export const GET_CURRENT_USER_SUCCESS = 'GET_CURRENT_USER_SUCCESS';
export const GET_CURRENT_USER_FAIL = 'GET_CURRENT_USER_FAIL';
export const GET_SETTINGS_SUCCESS = 'GET_SETTINGS_SUCCESS';

export const LOGOUT = 'LOGOUT';

export function getCurrentUser() {
  return async dispatch => {
    dispatch({
      type: GET_CURRENT_USER,
    });

    try {
      const self = await request(config.auth.self);

      dispatch({
        type: GET_CURRENT_USER_SUCCESS,
        user: self.body,
      });
    } catch (err) {
      console.log(err);
      dispatch({
        type: GET_CURRENT_USER_FAIL,
      });
    }
  };
}

export function logout() {
  auth.logout();
}
